<template>
  <div v-if="category">
    <div class="overlay" @click.self="$emit('closeModal')">
      <div class="modal">
        <div class="modal__head">
          <p>
            {{ category.name }}
          </p>
          <span class="modal__close" @click="$emit('closeModal')">
            <i class="fa fa-lg fa-close" aria-hidden="true"></i>
          </span>
        </div>
        <div class="modal__body">
          <p class="mb--lg">
            <strong>
              Voeg je eigen suggestie toe voor de categorie '{{ category.name.toLowerCase() }}'.</strong
            >
          </p>
          <template>
            <p v-if="category.name.toLowerCase() === 'man' || category.name.toLowerCase() === 'vrouw'">
              Wat is de naam van de persoon?
            </p>
            <p v-else-if="category.name.toLowerCase() === 'programma'">
              Wat is de naam van het programma?
            </p>
            <p v-else-if="category.name.toLowerCase() === 'podcast'">
              Wat is de naam van de podcast?
            </p>
            <p v-else-if="category.name.toLowerCase() === 'presentator'">
              Wat is de naam van de presentator?
            </p>
            <p v-else>
              Wat is de naam van het programma?
            </p>
          </template>
          <form class="form" ref="form" @submit.prevent="submit">
            <div class="form__field">
              <input
                type="text"
                required
                class="form__input mt--md"
                placeholder="Naam *"
                v-model="suggestionName"
                id="form__field_name"
              />
            </div>
            <template v-if="category.name.toLowerCase() !== 'podcast'">
              <p class="mt--md">
                Bij welk radiostation behoort je suggestie?
              </p>
              <div class="form__field">
                <select
                  class="form__input form__input--select mt--md"
                  v-model="suggestionStation"
                  required
                  id="form__field_station"
                >
                  <option disabled :value="null">Selecteer een radiostation</option>
                  <option v-for="(station, index) in stations" :key="`station-${index}`" :value="station">
                    {{ station }}
                  </option>
                </select>
              </div>
            </template>
          </form>
        </div>
        <div
          :class="{
            'p--lg': windowHeight >= minHeight,
            'p--md': windowHeight < minHeight
          }"
        >
          <button class="button button--fullwidth" @click.prevent="addSuggestion" :disabled="isIncomplete()">
            Voeg suggestie toe
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import listen from '@/util/listen'
import throttle from '@/util/throttle'

const MIN_HEIGHT = 490
const { documentElement } = document

export default {
  name: 'Suggestion',
  props: {
    categoryId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      listeners: [],
      minHeight: MIN_HEIGHT,
      windowHeight: window.innerHeight,
      suggestionName: null,
      suggestionStation: null,
      stations: [
        '100%NL',
        'BNR Nieuwsradio',
        'Groot Nieuws Radio',
        'JOE',
        'KINK',
        'NPO 3FM',
        'NPO Klassiek',
        'NPO Radio 1',
        'NPO Radio 2',
        'NPO Radio 5',
        'Qmusic',
        'Radio 10',
        'Radio 538',
        'Radio Decibel',
        'Radio Veronica',
        'RadioNL',
        'SLAM!',
        'SterrenNL',
        'Sublime'
      ]
    }
  },
  mounted() {
    const detectWindowHeight = throttle(() => {
      this.windowHeight = window.innerHeight
    }, 500)

    this.listeners = [listen(window, 'keyup', this.onKeyUp), listen(window, 'resize', detectWindowHeight)]

    documentElement.classList.add('no-scroll')
  },
  beforeDestroy() {
    this.listeners.forEach(unlisten => unlisten())
    documentElement.classList.remove('no-scroll')
  },
  methods: {
    submit() {
      if (this.isValid()) {
        this.addSuggestion()
      }
    },
    onKeyUp(e) {
      if (e.keyCode === 27) {
        this.$emit('closeModal')
      }
    },
    isValid() {
      const hasSuggestion = this.suggestionName && this.suggestionName.trim().length > 0
      const hasStation =
        this.category.name.toLowerCase() === 'podcast' || this.stations.includes(this.suggestionStation)
      return hasSuggestion && hasStation
    },
    isIncomplete() {
      return !this.isValid()
    },
    addSuggestion() {
      const { categoryId, suggestionName, suggestionStation } = this

      this.$store.dispatch('addSuggestion', {
        categoryId,
        suggestionName,
        suggestionStation
      })

      this.$emit('closeModal')
    }
  },
  computed: {
    ...mapState(['selected', 'categories']),
    category() {
      return this.categories.find(({ id }) => id === this.categoryId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SuggestionModal.vue